import { Action } from '@ngrx/store';

export enum ESelectedProcedureActions {
  UpdateSelectedProcedure = '[PROCEDURE] Selected procedure'
}

export class UpdateSelectedProcedure implements Action {
  public readonly type = ESelectedProcedureActions.UpdateSelectedProcedure;
  constructor(public payload?: string) {}
}

export type SelectedProcedureActions = UpdateSelectedProcedure;
